import React from 'react';
import { formatDate } from '../../utils/formatDate';
import { getConfiguration } from '../../utils/configuration';
import { oddToStringCheckbet } from '../../utils/oddToStringCheckbet';
import EventInfo from './EventInfo';
import { WidgetContext, useWidgetContext } from '../../widgets/WidgetContext';
import ScoreAndTime from './ScoreAndTime';
import { xs_isMobile } from '../../..';
import LiveTrackerToggle from './LiveTrackerToggle';
import LiveTracker from './LiveTracker';
import { calculateBetBuilderOdd } from '../../utils/calculateBetBuilderOdd';
import { getLabel } from '../../labels';

const getEsitoClass = function (betStatus, winning, winningDrawCode) {
    if (betStatus === 'voided') {
        return 'esito-vd';
    }
    if (!['winning', 'losing'].includes(betStatus) || !winningDrawCode) {
        return 'esito-nd';
    }
    return winning ? 'esito-v' : 'esito-p';
}

function getUrl(event) {
    const conf = getConfiguration();
    let url = null;

    try {
        const routes = window.appConfig.ROUTES;
        const prematchPath = conf.xspu?.pm;
        const livePath = conf.xspu?.lv;

        if (xs_isMobile) {
            url = `https://${conf.url}${prematchPath || routes.prematch.prematch}/_${event.sportRef}_${event.categoryRef}_${event.tournamentRef}_${event.pal}_${event.avv}`;
        } else {
            url = `https://${conf.url}${prematchPath || routes.prematch['top-match']}/_${event.sportRef}_${event.categoryRef}_${event.tournamentRef}_${event.pal}_${event.avv}`;
        }
        
    } catch (err) {
        console.error(err);
    }

    return url;
}

function EventsList(props) {
    const conf = getConfiguration();
    const [widgetContext] = useWidgetContext('#br_widget');
    const isV3 = conf.mbt === 'V3';

    return (
        <WidgetContext.Provider value={widgetContext}>
            {props.events.map((event, i) => {
                const parts = event.desc.split(' - ');
                let team1Score = parts?.[0] ?? '';
                let team2Score = parts?.[1] ?? '';
                const dataEvent = formatDate(event.timestamp).formatted;
                const showBetBuilderOdd = (props.isBetBuilder || event.betBuilderReducedOdd) && conf.bbc.type === 'ITALIA' && event.bets.length > 0;

                return (
                    <React.Fragment key={`${event.id}_${i}`}>
                        <>
                            <EventItem event={event} isCheckbet={props.isCheckbet} >
                                <div className='event-list__event-item__wrapper'>
                                    <div className="event-list__event-body__wrapper d-flex flex-column margine-su-giu | mb_10_1">
                                        <EventInfo isPsv={props.isPsv} event={event} isSystem={props.isSystem} />
                                        <div className='event-teams-data-wrapper'>
                                            <div className="mb_10_2">
                                                <div className="d-flex align-items-center text-medium bold desc-event-checkbet | mb_10_2_1">
                                                    <span className='event-list__team1Score'>{team1Score}</span>
                                                    {/* {event.desc} */}
                                                    {event.score?.length > 0 ?
                                                        <span className="mb_10_2_1_1">{event.score.replace(':', ' - ')}</span>
                                                        :
                                                        <span className="event-noscore__separator">-</span>
                                                    }
                                                    {props.isSystem && !event.var &&
                                                        <span className="ml-auto mr-2 bold | mb_10_2_1_2">F</span>
                                                    }
                                                    <span className='event-list__team2Score'>{team2Score}</span>
                                                </div>
                                                <ScoreAndTime {...event} />
                                            </div>


                                            <div className='event-list__data-event'>{dataEvent}</div>
                                        </div>
                                        {event.bets.map((bet, i) => {
											const showOdd = (!props.isBetBuilder || (props.isBetBuilder && conf.bbc.sno)) && !event.betBuilderReducedOdd;
                                            return <div key={`${bet.id}_${bet.drawCode}_${i}`} className="grey-box | mb_10_3 event-list__outcome">
                                                <div className="event-list__outcome-symbol">
                                                    <span className={"esito | mb_10_3_2_1_3 " + getEsitoClass(bet.state, bet.isWinning, bet.winningDrawCode)}></span>
                                                </div>
                                                <span className="text-medium bold | mb_10_3_2_1_1"><span className='text__outcame'>{bet.desc}: </span><span className='text__drawDesc'>{bet.drawDesc}</span></span>

                                                {showOdd ?
                                                    <div className="d-flex | mb_10_3_2_1_2">
                                                        <span className="text-medium bold | mb_10_3_2_1_2_1">{oddToStringCheckbet(bet.odd)}</span>
                                                    </div>
                                                    :
                                                    <div className="mb_10_3_2_1_3"></div>
                                                }
                                            </div>
                                        })}
                                        {
                                            showBetBuilderOdd && <div className="grey-box show__betbuilder | mb_10_3 event-list__outcome">
                                                <span className="text-medium bold | mb_10_3_2_1_1">
                                                    <span className='text__outcame'>{getLabel('betbuilder.title')} - </span>
                                                    <span className='text__drawDesc'>{getLabel('mybets.quotatotale')}</span>
                                                </span>
                                                <div className="d-flex | mb_10_3_2_1_2">
                                                    <span className="text-medium bold | mb_10_3_2_1_2_1">{oddToStringCheckbet(event.betBuilderReducedOdd || calculateBetBuilderOdd(event.bets))}</span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </EventItem>
                            <LiveTracker event={event} />
                            {conf.fomb && isV3 &&
                                <LiveTrackerToggle event={event} />
                            }
                        </>
                    </React.Fragment>
                );
            })}
        </WidgetContext.Provider>
    );
}

function EventItem(props) {
    return (
        <>
            {window.appConfig?.XSHOP_TERMINAL || props.isCheckbet ?
                <div className="event d-flex flex-column | mb_10">{props.children} </div>
                :
                <a href={getUrl(props.event)} target="_blank" rel="nofollow,noindex,noreferrer" className="event d-flex flex-column | mb_10">{props.children}</a>
            }
        </>
    );
}

export default EventsList;